import {
    http,
    Header,
    ContentType,
    qs,
    GetFormData,
    StatusCode,
    Global,
    Method
} from './api-util';

/**
 * 关于我们
 */
export const aboutUs = async () => {
    const {data} = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/about-us.json`
    });

    return {info: data};
};

/**
 * app
 */
export class AppConfig {
    platformName = ''
    websiteName = ''
    domain = ''
    email = ''
    adminDomain = ''

    fill(appConfig) {
        this.platformName = appConfig.platformName;
        this.websiteName = appConfig.websiteName;
        this.domain = appConfig.domain;
        this.email = appConfig.email;
        this.adminDomain = appConfig.adminDomain;
    }
}

export const app = async () => {
    const {data} = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/app.json`
    });

    return {info: data};
};

/**
 * home
 */
export const home = async () => {
    const {data} = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/home.json`
    });

    return {info: data};
};

/**
 * contact
 */
export const contact = async () => {
    const {data} = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/contact.json`
    });

    return data;
};

/**
 * 网站有关信息
 */
export const website = async () => {
    const {data} = await http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/website.json`
    });

    return {info: data};
};

export const recordUrl = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/record-url.json`
    }).then(res => res.data)
        .then(data => data.recordUrl)
}

export const recordTime = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/record-time.json`
    }).then(res => res.data)
        .then(data => data.recordTime)
}

/**
 * ai
 * @returns {*}
 */
export const aiConfig = async () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/ai.json`,
    }).then(res => res.data)
}

/**
 * nav
 * @returns {*}
 */
export const nav = async () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/nav.json`,
    }).then(res => res.data)
}